
import React, { useState, useEffect } from 'react'
import Dashboard from 'src/views/dashboard/Dashboard'
import {
    CNav,
    CNavItem,
    CNavLink,
    CRow,
    CTabContent,
    CTabPane,
    CModal,
    CTabs,
    CModalBody,
    CModalFooter,
    CModalHeader,
    CModalTitle,
    CBadge,
    CDataTable,
    CButton,
    CCard,
    CCardBody,
    CCardFooter,
    CCardHeader,
    CCol,
    CForm,
    CSelect,
    CFormGroup,
    CInputGroupAppend,
    CInputGroup,
    CLabel,
    CInputCheckbox,
    CSwitch,
    CFormText,
    CInput,
    CInputFile
} from '@coreui/react'
import './ctc.css'
import Moment from 'react-moment';

import API from '../../utils/apiCalling';
import { config } from '../../utils/apiUrl';
const Ctc = (props) => {
    const { condidate, ctcResult, joiningDate, todayDate } = props
    const api = new API()

    const [isCTCFullDetails, setIsCTCFullDetails] = useState(false)
    // const [large, setLarge] = useState(false)
    useEffect(() => {

    }, [])



    // const isModalOpen = () => {
    //     setLarge(!large)
    // }
    const ctcFullDetails = () => {

        setIsCTCFullDetails(true)
    }
    return (
        <div classNameNameName="">
            <body width="100%" style={{ margin: "0", padding: "0" }}>
                <center style={{ width: "100%", backgroundColor: "#f1f1f1" }}>

                    <div style={{ maxWidth: "950px", margin: "0 auto", backgroundColor: "#fff" }} className="email-container" >
                        <div style={{ maxWidth: "950px", margin: "0 auto" }} className="image-hr" >

                        </div>
                        <table align="center" role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style={{ margin: "auto" }}>

                            <tr>
                                <td valign="top" className="bg_white" style={{ padding: "1em 2.5em" }}>
                                    <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
                                        <tr>
                                            <td width="40%" className="logo" style={{ textAlign: "right" }}>
                                                <h1><img src="images/qdegrees.png" /></h1>
                                            </td>

                                        </tr>
                                    </table>
                                </td>
                            </tr>




                            <tr>
                                <td className="">
                                    <div className="70%">


                                        <table className="table table-bordered" style={{ border: "1px soild", width: "85%", margin: "auto" }}>
                                            <thead>
                                                <tr>
                                                    <th>Name:</th>
                                                    <td colspan="2" style={{ textAlign: "center" }}><strong className="hr-color">{condidate && condidate.firstName} {condidate && condidate.lastName}</strong></td>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th>Function:</th>
                                                    <td colspan="2" style={{ textAlign: "center" }}><strong className="hr-color">{condidate && condidate.Department}</strong></td>

                                                </tr>
                                                <tr>
                                                    <th>Location :</th>
                                                    <td colspan="2" style={{ textAlign: "center" }}><strong className="hr-color">{condidate && condidate.Location}</strong></td>
                                                </tr>
                                                <tr>
                                                    <th>Designation</th>
                                                    <td colspan="2" style={{ textAlign: "center" }}><strong className="hr-color">{condidate && condidate.Role}</strong></td>


                                                </tr>
                                                <tr style={{ padding: "10px" }}>
                                                    <th >Compensation Break up</th>
                                                    {/* <tr> */}
                                                    <th style={{ textAlign: "center" }}>Monthly</th>
                                                    <th style={{ textAlign: "center" }}>Annual</th>
                                                    {/* </tr> */}
                                                </tr>
                                                <tr>
                                                    <td>Basic </td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.basic}</strong></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.basic * 12}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td>HRA </td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.hra}</strong></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.hra * 12}</strong></td>
                                                </tr>

                                                <tr>
                                                    <td>Petrol Allowance </td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.Petrol_Allowance}</strong></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.Petrol_Allowance * 12}</strong></td>
                                                </tr>

                                                <tr>
                                                    <td>Attendance Allowance</td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.Attendance_Allowance}</strong></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.Attendance_Allowance * 12}</strong></td>
                                                </tr>

                                                <tr>
                                                    <td>Canteen Allowance </td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.Canteen_Allowance}</strong></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.Canteen_Allowance * 12}</strong></td>
                                                </tr>
                                                {/* 
                                                <tr>
                                                    <td>Medical Allowance </td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.basic}</strong></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.basic}</strong></td>
                                                </tr>

                                                <tr>
                                                    <td>LTA</td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.basic}</strong></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.basic}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td>Meal Allowance </td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.basic}</strong></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.basic}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td>Management Allowance</td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.basic}</strong></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.basic}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td>Education Allowance</td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.basic}</strong></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.basic}</strong></td>
                                                </tr> */}

                                                <tr style={{ backgroundColor: "rgb(228, 228, 228)" }}>
                                                    <td><b>Gross</b></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.gross}</strong></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.gross * 12}</strong></td>
                                                </tr>
                                                <td><b>Employee's Contribution</b></td>

                                                <tr>
                                                    <td>PF  - Employee Contributions </td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.pfEmployee}</strong></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.pfEmployee * 12}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td>ESI - Employee Contribution  </td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.esiEmployee}</strong></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.esiEmployee * 12}</strong></td>
                                                </tr>

                                                <tr>
                                                    <td><b>Total Employee's Contribution</b></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.totalEmployeeContribution}</strong></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.totalEmployeeContribution * 12}</strong></td>
                                                </tr>


                                                <td><b>Employers Contribution</b> </td>


                                                <tr>
                                                    <td>PF  - Employee Contributions </td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.pfEmployer}</strong></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.pfEmployer * 12}</strong></td>
                                                </tr>

                                                <tr>
                                                    <td>PF  - Employee Contributions </td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.esiEmployer}</strong></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.esiEmployer * 12}</strong></td>
                                                </tr>

                                                <tr>
                                                    <td>ESI  - Employee Contributions </td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.totalEmployerContribution}</strong></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.totalEmployerContribution * 12}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td>GMC </td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.GMC}</strong></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.GMC * 12}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td><b>Total Employer's Contribution</b></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.totalEmployerContribution}</strong></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.totalEmployerContribution * 12}</strong></td>
                                                </tr>
                                                {/* <tr>
                                                    <td>CTC [A] </td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.basic}</strong></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.basic}</strong></td>
                                                </tr> */}

                                                <tr>
                                                    <td>Performance Bonus (Variable Pay) [B] </td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.performanceBonus}</strong></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.performanceBonus * 12}</strong></td>
                                                </tr>


                                                <tr style={{ backgroundColor: "rgb(107, 199, 16)" }}>
                                                    <td><b>Total CTC (A+B+C)</b></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.newCtc}</strong></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.newCtc * 12}</strong></td>
                                                </tr>

                                                <tr style={{ backgroundColor: "rgb(107, 199, 16)" }}>
                                                    <td><b>Take Home</b> </td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.takeHome}</strong></td>
                                                    <td style={{ textAlign: "center" }}><strong className="hr-color">{ctcResult && ctcResult.takeHome * 12}</strong></td>
                                                </tr>

                                            </tbody>
                                        </table>


                                        <p style={{ paddingLeft: "2.5em", fontFamily: "Georgia, 'Times New Roman', Times, serif", fontSize: "medium" }}>*Performance Bonus will be paid quarterly basis. (An employee should be live/not in notice in the company during performance bonus payout)</p>
                                        <p style={{ paddingLeft: "2.5em", fontFamily: "Georgia, 'Times New Roman', Times, serif", fontWeight: "600" }}>Disclaimer: This document is a confidential and is explicitly reserved to QDegrees. QDegrees is only authorized to modify any clause mentioned in the document at any point of time.</p>

                                        <p style={{ paddingLeft: "2.5em", fontFamily: "cursive", fontWeight: "700" }}>For QDegrees Services Pvt. Ltd.</p>


                                        <p style={{ paddingLeft: "2.5em", fontWeight: "700" }}>Sonam Rara </p>
                                        <p style={{ paddingLeft: "2.5em", fontWeight: "700" }}>Head – Human Resource</p>
                                        <p style={{ paddingLeft: "2.5em", fontFamily: "monospace" }}>I have read and accept the terms and conditions:</p>

                                    </div>

                                </td>
                            </tr>
                        </table>

                        <tr>
                            <td>
                                <table>
                                    <tr>

                                        <td valign="middle" width="20%" style={{padding:"10px"}}>
                                            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                                                <tr>
                                                    <td className="counter-text">

                                                        <span className="name">Date of Joining</span>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                        <td valign="middle" width="20%">
                                            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                                                <tr>
                                                    <td className="counter-text">

                                                        <span className="name"><strong className="hr-color">{joiningDate && joiningDate}</strong> </span>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                        <td valign="middle" width="20%">
                                            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                                                <tr>
                                                    <td className="counter-text">

                                                        <span className="name">Signature</span>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                        <td valign="middle" width="20%">
                                            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                                                <tr>
                                                    <td className="counter-text">

                                                        <span className="name"><strong className="hr-color">-------</strong> </span>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <td valign="middle" width="20%">
                                        <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                                            <tr>
                                                <td className="counter-text">

                                                    <span className="name">Date </span>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>

                                    <td valign="middle" width="20%">
                                        <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                                            <tr>
                                                <td className="counter-text">

                                                    <span className="name"><strong className="hr-color">     <td><Moment format="YYYY/MM/DD">
                                                        {todayDate}
                                                    </Moment></td></strong> </span>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>


                                </table>
                            </td>
                        </tr>

                    </div>
                    {/* </div> */}
                </center >
            </body >
        </div >


    )
}
export default Ctc







